module.exports = __webpack_public_path__ + "static/media/AppFeaturesScreenShot.7bc48f9e.png";